import {
  SET_SANKEY_OPTIONS_NAMES,
  SET_SANKEY_OPTIONS_COSTS,
  SET_SANKEY_OPTIONS_VALUES
} from '../constants/actionTypes';

export default (
  state = { showNames: true, showValues: false, showCosts: false },
  action
) => {
  switch (action.type) {
    case SET_SANKEY_OPTIONS_COSTS:
      return {
        ...state,
        showCosts: action.payload
      };
    case SET_SANKEY_OPTIONS_VALUES:
      return {
        ...state,
        showValues: action.payload
      };
    case SET_SANKEY_OPTIONS_NAMES:
      return {
        ...state,
        showNames: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/sankeyOptions.js